import Config from 'config/settings';
import { particles } from 'app/contracts/Particles';
import { ParticleBehaviourTagType } from 'app/enum/Particles';
import { ParticleBehaviour } from '../ParticleBehaviour';

export class ParticleTint extends ParticleBehaviour implements particles.ParticleColour {
	//Set default tag type for behaviour:Particles
	protected _tags: Array<ParticleBehaviourTagType> = [ParticleBehaviourTagType.TINT];
	private _tint: number;

	//PUBLIC METHODS
	//-------------------------------------------------------------------------------------
	public set(tint: number) {
		this._particleProps.sprite.tint = tint;
		this._tint = tint;
	}

	public get(): number {
		return this._tint;
	}

	public tween(tint: number, time: number = 0.7) {
		gsap.TweenMax.fromTo(
			this._particleProps.sprite,
			time,
			{ pixi: { tint: this._tint } },
			{ pixi: { tint: tint }, ease: Config.linearEase }
		);
		this._tint = tint;
	}
}
